import { Component, ViewEncapsulation, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Utility } from '../../shared/utility/utility';
import { EmitterService } from '../../services/emitter.service';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { Meta, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-pagenotfound',
  templateUrl: './pagenotfound.component.html',
  styleUrls: ['./pagenotfound.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PagenotfoundComponent implements OnDestroy, OnInit {
  langCode;
  destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    private utility: Utility,
    private router: Router,
    private emitterService:EmitterService,
    private metaService: Meta,
    private titleService:Title,
    private translate: TranslateService,

  ) {
    this.langCode = localStorage.getItem('langCode') ? localStorage.getItem('langCode') : "en";
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode =>{
      this.langCode = langCode;
    });
  }
 ngOnInit(): void {
  this.translate.getTranslation(this.langCode).subscribe(res => {
    let pageNotFoundTitle = res['footersticknavComp']['footersticknav25'];
     this.titleService.setTitle(pageNotFoundTitle);
     this.metaService.addTag({name: 'robots', content: 'noindex'});
     this.metaService.addTag({ name: 'prerender-status-code', content: "404" });  
  });}

  closeModal(modalId){
    this.utility.closeModal(modalId);
  }

  gotoHome(){
    this.router.navigate([this.langCode])
  }

  ngOnDestroy() {
    this.metaService.removeTag("name='prerender-status-code'");
    this.metaService.removeTag("name='robots'");
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
